import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1742f6e3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1742f6e3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742f6e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1742f6e3')) {
      api.createRecord('1742f6e3', component.options)
    } else {
      api.reload('1742f6e3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1742f6e3&scoped=true", function () {
      api.rerender('1742f6e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Dashboards/index.vue"
export default component.exports